export const SHIP_SALES_ORDERS_TOGETHER_REQUEST = 'SHIP_SALES_ORDERS_TOGETHER_REQUEST';
export const shipSalesOrdersTogether = (selectedShipmentId, selectedOrderId, shipTogetherItems, fulfillmentPlanIdsWithoutItems) => ({
  type: SHIP_SALES_ORDERS_TOGETHER_REQUEST,
  selectedShipmentId,
  selectedOrderId,
  shipTogetherItems,
  fulfillmentPlanIdsWithoutItems,
});

export const SHIP_SALES_ORDERS_TOGETHER_SUCCESS = 'SHIP_SALES_ORDERS_TOGETHER_SUCCESS';
export const shipSalesOrdersTogetherSuccess = (response, selectedOrderId, shipTogetherItems, fulfillmentPlanIdsWithoutItems) => ({
  type: SHIP_SALES_ORDERS_TOGETHER_SUCCESS,
  response,
  selectedOrderId,
  shipTogetherItems,
  fulfillmentPlanIdsWithoutItems,
});

export const SHIP_SALES_ORDERS_TOGETHER_FAILURE = 'SHIP_SALES_ORDERS_TOGETHER_FAILURE';
export const shipSalesOrdersTogetherFailure = (err) => ({
  type: SHIP_SALES_ORDERS_TOGETHER_FAILURE,
  err,
});
